export default "__VITE_ASSET__c3IQy2E2__"